
import Entity from '../abstract/Entity';
import { IRadiator } from './RadiatorModel';

export interface IWallSide {
  radiators: IRadiator[];
  // later: finish/material/paint/outlets etc etc
}

export class WallSideModel extends Entity implements IWallSide {
  constructor(public radiators: IRadiator[] = []) { super(); }
  addRadiator(r: IRadiator) { if (!this.radiators.find(x => x.uuid === r.uuid)) this.radiators.push(r); }
  removeRadiator(id: string) {
    const i = this.radiators.findIndex(r => r.uuid === id);
    if (i === -1) return false; this.radiators.splice(i, 1); return true;
  }
}
